module.exports= {
  currency: [
    {
      symbol: "₹",
      name: "INR",
      slug: "inr_pricings",
    },
    {
      symbol: "$",
      name: "USD",
      slug: "usd_pricings",
    },
  ],
  usd_pricings: [
    {
      title: "BEGINNER",
      subtitle: "Free Forever",
      subtext: "No credit card required",
      price: [
        {
          id: "",
          prefix: "",
          price_slug: "",
          text: "$0",
          postfix: "",
          message: "GO 🌲 GREEN",
        },
      ],
      features: [
        {
          text: "Single Card",
          img: "beginner_plan_images/single_card.png",
          subtitle: "Get your primary card instantly with sign up",
        },
        {
          text: "Unlimited Sharing",
          img: "beginner_plan_images/single_card.png",
          subtitle:
            "Share anywhere anytime with unique link, Qr Code and NFC Card ",
        },
        {
          text: "Digital Responsive Card",
          img: "beginner_plan_images/single_tap_actions.png",
          subtitle:
            "Your digital cards are fit for your mobile screen. Explore all details with ease.",
        },
        {
          text: "Single Tap Actions",
          img: "beginner_plan_images/digital_responsive_card.png",
          subtitle:
            "Single tap to dial call, send sms, email, explore social media and website for ease of networking. ",
        },
        {
          text: "QR Contact & Download",
          img: "beginner_plan_images/qr_contact&download.png",
          subtitle:
            "Scan QR to save or download to save a contact to your android and ios mobile as VCF(vCard File)",
        },
        {
          text: "Social & Web Links",
          img: "beginner_plan_images/social_web_links.png",
          subtitle:
            "Add your social media profiles and website links quick and easy.",
        },
        {
          text: "Business Details",
          img: "beginner_plan_images/business_details.png",
          subtitle:
            "Add your business description and list services with rich editor for full insight to your prospect.",
        },
        {
          text: "Color customization",
          img: "beginner_plan_images/color_customization.png",
          subtitle:
            "Customize card icons and text color in addition dark and light mode as per your brand color.",
        },
      ],
      checkout: "Get Started",
      checkout_link: "https://byvisit.com/download",
    },
    {
      title: "STANDARD",
      subtitle: "7 DAYS free trial",
      subtext: "With Professional Features",
      price: [
        {
          id: "price_1MTkOnSDc8upCW0WHTeMo2kr",
          price_slug: "standard_plan_usd",
          prefix: "<del>$48</del>",
          text: "$24",
          postfix: "Yearly",
          message: "Inclusive of taxes",
        },
        // {
        //   id: "price_1MSdcYSDc8upCW0WdUu5lKz0",
        //   price_slug: "standard_plan_usd_monthly",
        //   prefix: "Only",
        //   text: "$5",
        //   postfix: "Monthly",
        //   message: "Inclusive of taxes",
        // },
      ],
      features: [
        {
          text: "All Beginner Features",
          img: null,
          subtitle: "",
        },
        {
          text: "Card Privacy",
          img: "basic_plan_images/card_privacy.png",
          subtitle:
            "Private your card with 6 digit PIN from general public to protect your card and contact informations.",
        },
        {
          text: "Private Card Sharing",
          img: "basic_plan_images/private_card_sharing.png",
          subtitle:
            "Share your private card with auto-generated 10 minute accessible link fom app to let access your prospect without a pin number.",
        },
        {
          text: "Intro image sharing",
          img: "basic_plan_images/intro_image_sharing.png",
          subtitle:
            "Update your intro image that increases the personalisation value of your digital contact card while sharing over social/professional media chats.",
        },
        {
          text: "Card Analytics",
          img: "standard_plan_images/analaytics.png",
          subtitle:
            "Analyze your digital card views and clicks with additional insight of engagement from published digital contact card. ",
        },
        {
          text: "Private Contact",
          img: "standard_plan_images/private_contact.png",
          subtitle:
            "Do you want to get your digital card visible but want to hide your contacts from strangers ? It is for your ease.",
        },
        {
          text: "Contact Request Inbox",
          img: "standard_plan_images/contact_Inbox.png",
          subtitle:
            "If you think about how people will contact you if contacts are private! Well here in the inbox you can have contact access request to share with them directly.",
        },
        {
          text: "Primary + 5 Sub Cards  ",
          img: "standard_plan_images/multiple_cards.png",
          subtitle:
            "Get three more sub cards and a primary card with all standard features.",
        },
        {
          text: "Gallery",
          img: "standard_plan_images/gallery.png",
          subtitle:
            "Let your networking connections explore about your business with photos direct from your digital card.",
        },
        {
          text: "Brochures",
          img: "standard_plan_images/brochure.png",
          subtitle:
            "Share your detailed brochures and menus with your connections to turn them into customers direct through your digital card.",
        },
        {
          text: "Custom Backgrounds",
          img: "standard_plan_images/custom_backgrounds.png",
          subtitle:
            "Upload customised backgrounds to your digital visiting card as you want from your media storage. ",
        },
        {
          text: "Unsplash Backgrounds",
          img: "standard_plan_images/unsplash_backgrounds.png",
          subtitle:
            "Explore free stock photos of unsplash and set as your digital card background as per your profession.",
        },
        {
          text: "Multiple Theme Templates",
          img: "standard_plan_images/multiple_theme_templates.png",
          subtitle:
            "Get additional card theme templates to organise your details differently accessible.",
        },
        {
          text: "Paper Card Scan",
          img: "standard_plan_images/paper_card_scans.png",
          subtitle:
            "Digitize paper contact cards from your connections and let save it to your contacts directly. ",
        },
        {
          text: "Contact Cards Book",
          img: "standard_plan_images/contact_cards_book.png",
          subtitle:
            "Contact cards book let you explore your contact cards image with your saved details to modify later.",
        },
      ],
      checkout: "Get Started",
      checkout_link:
        "https://api.whatsapp.com/send?phone=917016780153&text=Hello%2C%20I%20am%20interested%20to%20subscribe%20STANDARD%20plan...%20Let%20me%20checkout.",
    },
    {
      title: "ENTERPRISE",
      subtitle: "Contact Us",
      subtext: "FOR LARGE BUSINESS ENTITIES",
      price: [
        {
          id: 2,
          prefix: "Under Development",
          text: "",
          postfix: "",
          message: "Get Tailored Solutions",
        },
      ],
      features: [
        {
          text: "All Standard Features",
          img: null,
          subtitle: "",
        },
        {
          text: "5+ Business Users",
          img: null,
          subtitle: "",
        },
        {
          text: "Data Export/Import",
          img: null,
          subtitle: "",
        },
        {
          text: "White-label Cards",
          img: null,
          subtitle: "",
        },
        {
          text: "Dedicated Support",
          img: null,
          subtitle: "",
        },
        {
          text: "Third Party Integration",
          img: null,
          subtitle: "",
        },
      ],
      maintainance: true,
      checkout: "Contact Us",
      checkout_link:
        "https://api.whatsapp.com/send?phone=918866118440&text=Hello%2C%20I%20am%20interested%20to%20subscribe%20BUSINESS%20plan...%20Let%20me%20checkout.",
    },
  ],
  inr_pricings: [
    {
      title: "BEGINNER",
      subtitle: "Free Forever",
      subtext: "No credit card required",
      price: [
        {
          id: "",
          prefix: "",
          price_slug: "",
          text: "₹0",
          postfix: "",
          message: "GO 🌲 GREEN",
        },
      ],
      features: [
        {
          text: "Single Card",
          img: "beginner_plan_images/single_card.png",
          subtitle: "Get your primary card instantly with sign up",
        },
        {
          text: "Unlimited Sharing",
          img: "beginner_plan_images/single_card.png",
          subtitle:
            "Share anywhere anytime with unique link, Qr Code and NFC Card ",
        },
        {
          text: "Digital Responsive Card",
          img: "beginner_plan_images/single_tap_actions.png",
          subtitle:
            "Your digital cards are fit for your mobile screen. Explore all details with ease.",
        },
        {
          text: "Single Tap Actions",
          img: "beginner_plan_images/digital_responsive_card.png",
          subtitle:
            "Single tap to dial call, send sms, email, explore social media and website for ease of networking. ",
        },
        {
          text: "QR Contact & Download",
          img: "beginner_plan_images/qr_contact&download.png",
          subtitle:
            "Scan QR to save or download to save a contact to your android and ios mobile as VCF(vCard File)",
        },
        {
          text: "Social & Web Links",
          img: "beginner_plan_images/social_web_links.png",
          subtitle:
            "Add your social media profiles and website links quick and easy.",
        },
        {
          text: "Business Details",
          img: "beginner_plan_images/business_details.png",
          subtitle:
            "Add your business description and list services with rich editor for full insight to your prospect.",
        },
        {
          text: "Color customization",
          img: "beginner_plan_images/color_customization.png",
          subtitle:
            "Customize card icons and text color in addition dark and light mode as per your brand color.",
        },
      ],
      checkout: "Get Started",
      checkout_link: "https://byvisit.com/download",
    },
    {
      title: "STANDARD",
      subtitle: "7 DAYS free trial",
      subtext: "With Professional Features",
      price: [
        {
          id: "price_1MreOcSDc8upCW0WbeEPDuXq",
          price_slug: "standard_plan_inr",
          prefix: "<del>₹1200</del>",
          text: "₹999",
          postfix: "Yearly",
          message: "Inclusive of taxes",
        },
        // {
        //   id: "price_1MSdcYSDc8upCW0WO0fonA3g",
        //   price_slug: "standard_plan_inr_monthly",
        //   prefix: "Only",
        //   text: "₹200",
        //   postfix: "Monthly",
        //   message: "Exclusive of taxes",
        // },
      ],
      features: [
        {
          text: "All Beginner Features",
          img: null,
          subtitle: "",
        },
        {
          text: "Card Privacy",
          img: "basic_plan_images/card_privacy.png",
          subtitle:
            "Private your card with 6 digit PIN from general public to protect your card and contact informations.",
        },
        {
          text: "Private Card Sharing",
          img: "basic_plan_images/private_card_sharing.png",
          subtitle:
            "Share your private card with auto-generated 10 minute accessible link fom app to let access your prospect without a pin number.",
        },
        {
          text: "Intro image sharing",
          img: "basic_plan_images/intro_image_sharing.png",
          subtitle:
            "Update your intro image that increases the personalisation value of your digital contact card while sharing over social/professional media chats.",
        },
        {
          text: "Card Analytics",
          img: "standard_plan_images/analaytics.png",
          subtitle:
            "Analyze your digital card views and clicks with additional insight of engagement from published digital contact card. ",
        },
        {
          text: "Private Contact",
          img: "standard_plan_images/private_contact.png",
          subtitle:
            "Do you want to get your digital card visible but want to hide your contacts from strangers ? It is for your ease.",
        },
        {
          text: "Contact Request Inbox",
          img: "standard_plan_images/contact_Inbox.png",
          subtitle:
            "If you think about how people will contact you if contacts are private! Well here in the inbox you can have contact access request to share with them directly.",
        },
        {
          text: "Primary + 5 Sub Cards  ",
          img: "standard_plan_images/multiple_cards.png",
          subtitle:
            "Get three more sub cards and a primary card with all standard features.",
        },
        {
          text: "Gallery",
          img: "standard_plan_images/gallery.png",
          subtitle:
            "Let your networking connections explore about your business with photos direct from your digital card.",
        },
        {
          text: "Brochures",
          img: "standard_plan_images/brochure.png",
          subtitle:
            "Share your detailed brochures and menus with your connections to turn them into customers direct through your digital card.",
        },
        {
          text: "Custom Backgrounds",
          img: "standard_plan_images/custom_backgrounds.png",
          subtitle:
            "Upload customised backgrounds to your digital visiting card as you want from your media storage. ",
        },
        {
          text: "Unsplash Backgrounds",
          img: "standard_plan_images/unsplash_backgrounds.png",
          subtitle:
            "Explore free stock photos of unsplash and set as your digital card background as per your profession.",
        },
        {
          text: "Multiple Theme Templates",
          img: "standard_plan_images/multiple_theme_templates.png",
          subtitle:
            "Get additional card theme templates to organise your details differently accessible.",
        },
        {
          text: "Paper Card Scan",
          img: "standard_plan_images/paper_card_scans.png",
          subtitle:
            "Digitize paper contact cards from your connections and let save it to your contacts directly. ",
        },
        {
          text: "Contact Cards Book",
          img: "standard_plan_images/contact_cards_book.png",
          subtitle:
            "Contact cards book let you explore your contact cards image with your saved details to modify later.",
        },
      ],
      checkout: "Get Started",
      checkout_link:
        "https://api.whatsapp.com/send?phone=917016780153&text=Hello%2C%20I%20am%20interested%20to%20subscribe%20STANDARD%20plan...%20Let%20me%20checkout.",
    },
    {
      title: "ENTERPRISE",
      subtitle: "Contact Us",
      subtext: "FOR LARGE BUSINESS ENTITIES",
      price: [
        {
          id: 2,
          prefix: "Under Development",
          text: "",
          postfix: "",
          message: "Get Tailored Solutions",
        },
      ],
      features: [
        {
          text: "All Standard Features",
          img: null,
          subtitle: "",
        },
        {
          text: "5+ Business Users",
          img: null,
          subtitle: "",
        },
        {
          text: "Data Export/Import",
          img: null,
          subtitle: "",
        },
        {
          text: "White-label Cards",
          img: null,
          subtitle: "",
        },
        {
          text: "Dedicated Support",
          img: null,
          subtitle: "",
        },
        {
          text: "Third Party Integration",
          img: null,
          subtitle: "",
        },
      ],
      maintainance: true,
      checkout: "Contact Us",
      checkout_link:
        "https://api.whatsapp.com/send?phone=918866118440&text=Hello%2C%20I%20am%20interested%20to%20subscribe%20BUSINESS%20plan...%20Let%20me%20checkout.",
    },
  ],
  compare: [
    {
      name: "Primary Card",
      tag: "",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "Card Sharing",
      tag: "",
      beginner: "Unlimited",
      standard: "Unlimited",
      business: "Unlimited",
    },
    {
      name: "Digital Responsive Card",
      tag: "",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "Single Tap Actions",
      tag: "",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "QR Contact & Download",
      tag: "",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "Social & Web Links",
      tag: "",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "Business Details",
      tag: "",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "Color customization",
      tag: "New",
      beginner: true,
      standard: true,
      business: true,
    },
    {
      name: "Primary + Sub Card",
      tag: "",
      beginner: "",
      standard: "5 Sub cards",
      business: true,
    },
    {
      name: "Card Privacy",
      tag: "New",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Private Card Sharing",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Professional Card Template",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Social Links",
      tag: "",
      beginner: "2 Links",
      standard: "12 Links",
      business: true,
    },
    {
      name: "Web Links",
      tag: "",
      beginner: "1 link",
      standard: "3 link",
      business: true,
    },
    {
      name: "Phone & Emails",
      tag: "",
      beginner: "1 Phone & Emails",
      standard: "4 Phone & Emails",
      business: true,
    },
    {
      name: "Default Backgrounds",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Intro image sharing",
      tag: "New",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Card Analytics",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Private Contact",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Contact Request Inbox",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Gallery",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Brochures",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Custom Backgrounds",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Unsplash Backgrounds",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Multiple Card Templates",
      tag: "",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Paper Card Scan",
      tag: "New",
      beginner: "",
      standard: true,
      business: true,
    },
    {
      name: "Contact Cards Book",
      tag: "New",
      beginner: "",
      standard: true,
      business: true,
    },
  ]
}
